import React from 'react'
import { Box, Flex } from 'theme-ui'

import { PaymentListStyled, PaymentListItemStyled } from './styles'
import StaticImage from './../../atoms/ImageStatic'
import { PaymentListProps } from './types'

const PaymentList: React.FC<PaymentListProps> = ({ data }) => {
  return (
    <PaymentListStyled>
      <Flex as="ul" variant="paymentList.list">
        {data.map(({ key, image }) => {
          return (
            <Box as="li" {...{ key }} variant="paymentList.item">
              <PaymentListItemStyled>
                <StaticImage {...{ image }} />
              </PaymentListItemStyled>
            </Box>
          )
        })}
      </Flex>
    </PaymentListStyled>
  )
}

export default PaymentList
